import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateWaterPump } from '../../redux/ac_central/water_pump_actions';

const mapStateToProps = state => ({
  isDuplicating: state.ac.waterPump.isDuplicating,
  errorMessage: state.ac.waterPump.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateWaterPump(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/WaterPumpDuplicateModal.js